/* eslint-disable */

export const deepMerge = function(current, updates) {
  for (const key of Object.keys(updates)) {
    if (!current.hasOwnProperty(key) || typeof updates[key] !== 'object') current[key] = updates[key];
    else deepMerge(current[key], updates[key]);
  }
  return current;
}


export const allFields = function(fields) {
  for (const field of fields) {
    if (field.hasOwnProperty('fields')) {
      fields = fields.concat(allFields(field.fields))
    }
  }
  return fields
}
export const allFieldGroups = function(field_group) {
  return [field_group, ...field_group.fields.filter((f)=>
      f.type === 'FieldGroup'
  )];
};
export const fieldByID = function(field_group, id){
  return allFields(field_group.fields).find(f=>f.id===id) || { datahash: {} }
}

export const findFieldOption = function(field, optionID) {
  let values = []
  try{
    values = field.datahash.options.values || []
  }catch (e) {}
  return values.find(v=>v.option_id === optionID);
};

export const addDuplicatedFieldToFieldGroup = function (field, fieldGroup) {
  const dropIndex = fieldGroup.fields.indexOf(field) + 1;
  const copy = JSON.parse(JSON.stringify(field))
  const now = Date.now()
  const nowI = Math.floor(now / 1000)

  const newItem = {
    ...copy,
    uid: undefined,
    id: undefined,
    datahash: {
      ...copy.datahash,
      label: copy.datahash.label + ' (duplicate)',
      _js_id: now,
    },
    fields: (copy.fields||[]).map(f => ({ ...f, id: undefined, uid: undefined })),
  };

  // add the copied item the right place in the field list
  fieldGroup.fields.splice(dropIndex, 0, newItem);
}

// make a copy of the available field to insert into list based on
// button dragged over
export const dupAvailableField = function(field, field_group){
  const newItem = JSON.parse(JSON.stringify(field));
  const now = Math.floor(Math.random()*10e12)
  const nowI = Math.floor(now / 1000)

  // adding a page break option to respect form-wide setting
  if (field_group.buildable.options?.page_break) {
    newItem.datahash.page_break = true;
  }
  newItem.datahash._js_id=now
  newItem.show = true; // show settings by default
  return newItem
}

// map. JS type=> ruby class type
export const allBuildableTypes = {
  activity:             'Activity',
  assessment:           'Assessment',
  session:              'Session',
  registration:         'Registration',
  teacher_registration: 'TeacherRegistration',
  attendance:           'Attendance',
}
